 
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { Card } from 'react-bootstrap';
import { changeBgColor } from '@/utils/pre-load/changeBgColor';
import { useAppContext } from '@/Main';
import CardChartDropDown from '@/components/common/CardChartDropDown';

const GrowthAndDropsSkeleton = ({
  title,
  tooltip,
  width,
  margin,
  limit = 10
}) => {
  const {
    config: { theme }
  } = useAppContext();

  const numbers = [
    100, 120, 79, 32, 72, 10, 90, 50, 20, 38, 67, 20, 80, 11, 90, 35, 70, 15,
    34, 92, 14, 93, 49, 83, 37, 10, 90, 52, 72, 13, 70, 50, 20, 90, 95, 110
  ];
  return (
    <Card>
      <FalconCardHeader
        title={
          <div>
            {title}
            <HelpTooltip html={tooltip} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown />}
      />
      <Card.Body className="px-0">
        <div style={{ margin: '0px 20px 20px 20px', direction: 'ltr' }}>
          <div style={{ textAlign: 'center', margin: `0px ${margin}px` }}>
            {numbers.slice(0, limit).map((item, index) => (
              <div
                key={index}
                className="text_chart_loading d-block"
                style={{marginTop:17.5, width: `${item + width}px` }}
              ></div>
            ))}
          </div>
        </div>
      </Card.Body>

      <style>
        {`
            .text_chart_loading{
              background:${changeBgColor(theme)};
              background-size: 200% 100%;
              background-position: 100% 0;
            }
        `}
      </style>
    </Card>
  );
};

export default GrowthAndDropsSkeleton;
